import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {AngularMultiSelectModule} from '../../angular2-multiselect-dropdown/multiselect.component';
import {DatetimeModule} from '../../datetime/datetime.module';

import {CommonComponentsModule} from '../../../common-components.module';
import {AngularMaterialImportModule} from '../../angular-material-import-module/angular-material-import.module';
import {SendInvitationModalComponent} from './send-invitation-modal.component';
import {UtilsModule} from '../../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        RouterModule,
        AngularMultiSelectModule,
        DatetimeModule,
        CommonComponentsModule,
        AngularMaterialImportModule,
        UtilsModule
    ],
    declarations: [
        SendInvitationModalComponent
    ],
    exports: [
        SendInvitationModalComponent
    ],
    providers: [],
})
export class SendInvitationModalModule {
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/send-invitation-modal/send-invitation-modal.module.ts